import React from 'react';
import './Features.css';

// Defining the structure for a feature item
interface Feature {
  id: number;
  icon: string;
  title: string;
  description: string;
}

const Features: React.FC = () => {
  // A more detailed and compelling list of features
  const features: Feature[] = [
    {
      id: 1,
      icon: '🤖',
      title: 'Yapay Zeka Tarif Üretici',
      description: 'Malzemelerinin fotoğrafını çek veya seç, yapay zeka saniyeler içinde sana özel yüzlerce tarif hazırlasın.'
    },
    {
      id: 2,
      icon: '📦',
      title: 'Akıllı Kiler Yönetimi',
      description: 'Evdeki malzemelerini dijital kilerine ekle, alışveriş listeni otomatik oluştur ve gıda israfını önle.'
    },
    {
      id: 3,
      icon: '🎯',
      title: 'Kişiselleştirilmiş Damak Profili',
      description: 'Diyet tercihlerini, alerjilerini ve sevdiğin tatları belirt, sadece sana uygun önerilerin tadını çıkar.'
    },
    {
      id: 4,
      icon: '🎥',
      title: 'Geniş Video Kütüphanesi',
      description: '1000 den fazla HD video tarif ile en zor yemekleri bile adım adım, kolayca ve eğlenerek pişir.'
    },
    {
      id: 5,
      icon: '📊',
      title: 'Besin Değeri ve Kalori Takibi',
      description: 'Yediğin her yemeğin kalorisini ve besin değerlerini öğrenerek sağlıklı yaşam hedeflerine ulaş.'
    },
    {
      id: 6,
      icon: '🍽️',
      title: 'Akıllı Porsiyon Hesaplayıcı',
      description: 'Tarifleri misafir sayına göre 2 ila 8 porsiyon arasında kolayca ayarla, malzeme miktarını dert etme.'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="features-header">
          <h2 className="section-title">Mutfaktaki Süper Gücünüz</h2>
          <p className="section-subtitle">
            FoodQuick, yemek yapmayı kolaylaştıran, kişiselleştiren ve eğlenceli hale getiren akıllı özelliklerle dolu. 
            İşte sizi bekleyenlerden sadece birkaçı:
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
